<template>
  <el-menu mode="horizontal" :default-active="`/product/${mod}/${id}`" router>
    <el-menu-item :index="`/product/baike/${id}`">百科信息</el-menu-item>
    <el-menu-item :index="`/product/chain/${id}`">供应链信息</el-menu-item>
  </el-menu>
</template>


<script>
export default {
  name: "ProductHeader",
  props: ["mod", "id"]
};
</script>

<style lang="less" scoped>
</style>

